<template>
  <div id="cadastro">
    <div id="voltar">
      <h4>encontros</h4>
      <button @click.prevent="$emit('fechar')">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <div class="form">
      <div
        class="modal-body"
        v-if="!carregando"
      >
        <div
          v-if="encontroSelecionado.descricao == null"
          class="container-tabela"
        >
          <h4>{{ atividade.nome }}</h4>
          <div class="atividade-infos">
            Tipo: {{ formatarEnum(nomeSubtipo) }}
          </div>
          <div class="atividade-infos">
            Modalidade de Execução: {{ formatarEnum(atividade.modalidade) }}
          </div>
          <div class="atividade-infos">
            Modalidade de inscrição:
            {{ formatarEnum(atividade.modalidadeInscricao) }}
          </div>
          <div class="atividade-infos">
            Período de inscrições:
            {{ formatarData(atividade.dataInicioInscricao) }} -
            {{ formatarData(atividade.dataFimInscricao) }}
          </div>

          <div class="instrucao">
            Selecione um encontro para realizar a frequência:
          </div>

          <Carregamento v-if="carregando" />

          <div
            class="tabela-customizada"
            v-else
          >
            <table>
              <thead>
                <tr>
                  <th>Encontro</th>
                  <th>Horário</th>
                  <th>Data</th>
                  <th>Status frequência</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(encontro, index) in encontros"
                  :key="index"
                  @click="abrirCadastroFrequencia(encontro.encontroId)"
                  :class="{
                    desabilitado:
                      encontro.status !== 'EM_EXECUCAO' &&
                      encontro.status !== 'FINALIZADO',
                  }"
                >
                  <td>{{ encontro.descricao }}</td>
                  <td>
                    {{
                      formatarDataHora(encontro.inicio_periodo).split(" ")[1]
                    }}
                    - {{ formatarDataHora(encontro.fim_periodo).split(" ")[1] }}
                  </td>
                  <td>{{ formatarData(encontro.fim_periodo) }}</td>

                  <td class="coluna-status">
                    <div
                      v-if="
                        encontro.status === 'FINALIZADO' &&
                        temFrequenciaCadastrada(encontro.encontroId)
                      "
                      class="badge-status verde"
                    >
                      Frequência cadastrada
                    </div>
                    <div
                      v-else-if="
                        encontro.status === 'EM_EXECUCAO' &&
                        !temFrequenciaCadastrada(encontro.encontroId)
                      "
                      class="badge-status amarelo"
                    >
                      Realizar Frequência
                    </div>
                    <div
                      v-else-if="encontro.status === 'EM_EXECUCAO'"
                      class="badge-status roxo"
                    >
                      {{ formatarStatusEncontro(encontro.status) }}
                    </div>
                    <div
                      v-else
                      class="badge-status cinza"
                    >
                      {{ formatarStatusEncontro(encontro.status) }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--<div class="conteudo">
        <div class="tabela" v-if="encontroSelecionado.descricao == null">
          <div id="cabecalho">
            <h5>Encontros</h5>
          </div>
          <div v-if="carregando">
            <div>
              <p style="color: black;">carregando...</p>
            </div>
          </div>
          

          <div v-for="(encontro, index) in encontros" :key="index" class="encontros"
            :class="{ 'ultimo-encontro': index == encontros.length - 1 }" @click="encontroSelecionado = encontro">
            <div>{{ encontro.descricao }}</div>
            <div>Inicio: {{ formatarData(encontro.inicio_periodo) }}</div>
            <div>Fim: {{ formatarData(encontro.fim_periodo) }}</div>
            <div class="status-frequencia" v-if="carregarFrequencia(encontro.encontroId)">
              Frequência cadastrada
            </div>
            <div class="status-frequencia" v-else>
              Frequência não cadastrada
            </div>
            <div id="selecionar"><button
                @click="encontroSelecionado = encontro, carregarParticipantes()">Selecionar</button></div>
          </div>
        </div>
        <div id="lista-participantes" v-else-if="encontroSelecionado.descricao != null">
          <div id="cabecalho-participante">
            <div>
              <p>Nome</p>
            </div>
            <div>
              <p>Presente</p>
              <button @click="marcarTodos('presente')">
                marcar todos
              </button>
            </div>
            <div>
              <p>Faltou</p>
              <button @click="marcarTodos('faltou')">
                marcar todos
              </button>
            </div>
          </div>
          <div v-if="carregando">
            <div>
              <p style="color: black;">carregando...</p>
            </div>
          </div>
          <div class="participantes" v-if="!carregando" v-for="participante, index in participantesAtividade"
            :key="index">
            <div class="faltou" :class="{ 'presente': participante.presente }"
              @click="participante.presente = !participante.presente">{{ participante.infos.nome ||
                participante.infos.nomeParticipante }}</div>
            <div class="faltou" :class="{ 'presente': participante.presente }" @click="participante.presente = true">
              <input class="form-check-input" type="radio" v-model="participante.presente"
                :name="participante.participanteId" :value="true"></input>
            </div>
            <div class="faltou" :class="{ 'presente': participante.presente }" @click="participante.presente = false">
              <input class="form-check-input" type="radio" v-model="participante.presente"
                :name="participante.participanteId" :value="false"></input>
            </div>
          </div>
        </div>
        <div id="botoes" v-show="encontroSelecionado.descricao != null && !carregando">
          <button class="voltar" @click="handleVoltar()">Voltar</button>
          <button class="salvar" @click="enviarFrequencia()">Salvar</button>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script setup>
import {
  getCurrentInstance,
  onBeforeMount,
  onMounted,
  onUnmounted,
  ref,
  computed,
} from "vue";
import {
  formatarData,
  getLocalDateTime,
  formatarEnum,
  formatarDataHora,
} from "@/utils/FormatarEntradas";
import encontrosService from "@/service/encontrosService";
import frequenciaService from "@/service/frequenciaService";
import participantesAtividadeService from "@/service/participantesAtividadeService";
import router from "@/router";
import { useRoute } from "vue-router";
import atividadeService from "@/service/atividadeService";
import Carregamento from "@/components/common/Carregamento.vue";

const { proxy } = getCurrentInstance();
const encontros = ref([]);
const encontroSelecionado = ref({});
const participantesAtividade = ref([]);
const carregando = ref(true);
const atividade = ref(null);
const resolvedSubtipoNome = ref("");
const nomeSubtipo = computed(() => {
  if (!atividade.value) return "";
  if (
    typeof atividade.value.subtipo === "object" &&
    atividade.value.subtipo !== null
  ) {
    return atividade.value.subtipo.nome
      ? atividade.value.subtipo.nome.toLowerCase()
      : "";
  }
  return resolvedSubtipoNome.value;
});
const route = useRoute();
const frequenciaCacheado = ref({}); // Cache para não fazer múltiplas chamadas API

async function carregarFrequencia(encontroId) {
  try {
    const participantes = await frequenciaService.getFrequencia(encontroId);

    // Se conseguir buscar e tiver participantes, significa que há frequência cadastrada
    if (
      participantes &&
      Array.isArray(participantes) &&
      participantes.length > 0
    ) {
      return true; // Frequência cadastrada
    }

    return false; // Nenhuma frequência cadastrada
  } catch (error) {
    console.log(
      "Erro ao carregar frequência ou nenhuma frequência encontrada:",
      error
    );
    return false; // Assume que não tem frequência cadastrada se der erro
  }
}

async function carregarTodasFrequencias() {
  // Limpar cache anterior
  frequenciaCacheado.value = {};

  try {
    // Para cada encontro, carregar sua frequência uma vez
    for (const encontro of encontros.value) {
      try {
        const participantes = await frequenciaService.getFrequencia(
          encontro.encontroId
        );
        frequenciaCacheado.value[encontro.encontroId] =
          participantes &&
          Array.isArray(participantes) &&
          participantes.length > 0;
      } catch (error) {
        // Se der erro, assume que não tem frequência cadastrada
        frequenciaCacheado.value[encontro.encontroId] = false;
      }
    }
  } catch (error) {
    console.error("Erro ao carregar frequências:", error);
  }
}

function temFrequenciaCadastrada(encontroId) {
  return frequenciaCacheado.value[encontroId] ?? false;
}

async function carregarParticipantes() {
  carregando.value = true;
  const atividadeId = atividade.value.id;

  const frequenciaCadastrada = await carregarFrequencia(
    encontroSelecionado.value.encontroId
  ); //carrega a frequência cadastrada no encontro

  if (!frequenciaCadastrada) {
    //Verifica se o encontro possui uma frequência cadastrada
    try {
      const participantes =
        await participantesAtividadeService.getParticipantesAtividade(
          0,
          50,
          atividadeId
        );
      const vetorAux = [];

      participantes.map((participante) => {
        vetorAux.push({
          infos: participante,
          presente: false,
        });
      });

      participantesAtividade.value = vetorAux;

      participantesAtividade.value.sort((a, b) => {
        if (a.infos.nomeParticipante < b.infos.nomeParticipante) return -1;
        if (a.infos.nomeParticipante > b.infos.nomeParticipante) return 1;
        return 0;
      });
    } catch (error) {
      console.log(error);
    } finally {
      carregando.value = false;
    }
  }
  carregando.value = false;
}

async function enviarFrequencia() {
  let presentes = [];
  participantesAtividade.value.map((participante) => {
    if (participante.presente) {
      presentes.push({
        frequenciaComInscricao: {
          participanteId: participante.infos.participanteId,
          dataHoraRegistro: getLocalDateTime(new Date(), "BR"),
        },
      });
    }
  });

  await frequenciaService.postFrequenciaMuitas(
    presentes,
    encontroSelecionado.value.encontroId
  );
}

async function carregarAtividade() {
  carregando.value = true;

  // Validar atividadeId
  let atividadeId =
    route.query.atividadeId ||
    route.query.atividade ||
    route.params.atividadeId;

  if (!atividadeId) {
    console.error("atividadeId não foi passado na URL");
    alert("Erro: Atividade não identificada. Verifique a URL.");
    carregando.value = false;
    return;
  }

  try {
    atividade.value = await atividadeService.getAtividadeId(atividadeId);

    resolvedSubtipoNome.value = "";
    if (atividade.value) {
      let subtipoId = null;
      if (
        typeof atividade.value.subtipo === "object" &&
        atividade.value.subtipo !== null
      ) {
        subtipoId = atividade.value.subtipo.id;
      } else {
        subtipoId =
          atividade.value.subtipoId ||
          atividade.value.subtipo_id ||
          atividade.value.subtipo;
      }

      if (subtipoId && !isNaN(subtipoId)) {
        try {
          const response = await atividadeService.getSubTipoPorId(subtipoId);
          if (response && response.data && response.data.nome) {
            resolvedSubtipoNome.value = response.data.nome.toLowerCase();
          }
        } catch (error) {
          console.error("Erro ao carregar o subtipo da atividade:", error);
        }
      }
    }

    encontros.value = await encontrosService.getEncontros(0, 50, atividadeId);

    if (!encontros.value || encontros.value.length === 0) {
      console.warn("Nenhum encontro encontrado para esta atividade");
    } else {
      // Carregar status de frequência para todos os encontros
      await carregarTodasFrequencias();
    }
  } catch (error) {
    console.error("Erro ao carregar atividade/encontros:", error);
    alert("Erro ao carregar atividade e encontros");
  } finally {
    carregando.value = false;
  }
}

function handleVoltar() {
  const resposta = confirm(
    "Você tem certeza que deseja voltar? você perderá todas as alterações feitas agora"
  );

  if (resposta) {
    encontroSelecionado.value = {};
  }
}

function abrirCadastroFrequencia(encontroId) {
  // Encontrar o encontro selecionado
  const encontroSelecionado = encontros.value.find(
    (e) => e.encontroId === encontroId
  );

  if (!encontroSelecionado) {
    alert("Erro: Encontro não identificado");
    return;
  }

  // Verificar se o encontro permite acesso (EM_EXECUCAO ou FINALIZADO)
  if (
    encontroSelecionado.status !== "EM_EXECUCAO" &&
    encontroSelecionado.status !== "FINALIZADO"
  ) {
    alert(
      `Este encontro não está disponível para frequência. Status: ${formatarStatusEncontro(
        encontroSelecionado.status
      )}`
    );
    return;
  }

  const atividadeId =
    route.query.atividadeId ||
    route.query.atividade ||
    route.params.atividadeId;

  if (!atividadeId) {
    alert("Erro: atividadeId não foi identificado");
    return;
  }

  if (!encontroId) {
    alert("Erro: encontroId não foi identificado");
    return;
  }

  const parts = route.path.split("/").filter(Boolean);
  let acaoId = route.params.id || route.params.acaoId;
  if (!acaoId && parts[0] === "acao" && parts[1]) {
    acaoId = parts[1];
  }

  // Construir path corretamente
  const newPath = `/acao/${acaoId}/Atividades/${atividadeId}/cadastro-frequencia/${encontroId}`;

  router.push(newPath);
}

function marcarTodos(situacao) {
  // marca todos os participantes de acordo com a situação selecionada(presente ou faltou)
  if (situacao === "presente") {
    participantesAtividade.value.map((participante) => {
      participante.presente = true;
    });
  } else if (situacao === "faltou") {
    participantesAtividade.value.map((participante) => {
      participante.presente = false;
    });
  }
}

function selecionarEncontro(encontro) {
  encontroSelecionado.value = encontro;
  carregarParticipantes();
}

function formatarStatusEncontro(status) {
  const statusMap = {
    EM_EXECUCAO: "Em Execução",
    PROGRAMADO: "Programado",
    FINALIZADO: "Finalizado",
    CANCELADO: "Cancelado",
    INSCRICOES_ABERTAS: "Inscrições Abertas",
  };
  return statusMap[status] || status;
}

onMounted(async () => {
  document.body.classList.add("modal-aberto");

  await carregarAtividade();
});

onUnmounted(() => {
  document.body.classList.remove("modal-aberto");
});
</script>

<style scoped>
/*.form {
  width: 80%;
  margin: 0 10%;
  background-color: var(--branco);
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}
#cadastro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7); 
  z-index:1000;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.tabela {
  width: 100%;
  display: flex;
  max-height: 40vh;
  overflow: auto;
  flex-wrap: wrap;
  justify-content: center;
}

#lista-participantes {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
  align-items: center;
}

#frequencia-atividade {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  width: 100%;
}

#conteudo {
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.316);
  padding: 3%;
  margin-top: 20px;
  border-radius: 25px;
  background-color: #f9f9f9;
  width: 80%;
}

h1 {
  color: #6f319aff;
  margin-bottom: 20px;
  border-bottom: 2px solid #6F319A;
}

h3 {
  text-align: center;
  font-size: 25px;
  color: #6f319aff;
  margin-bottom: 5%;
}

#cabecalho {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #6f319aff;
  width: 90%;
  height: 50px;
  border: 1px solid black;
  border-radius: 10px 10px 0 0;
}

.encontros {
  display: grid;
  width: 90%;
  grid-template-columns: repeat(5, 20%);
  justify-items: center;
  align-items: center;
  background-color: white;
}

.encontros div {
  text-align: center;
  align-content: center;
  margin: 2% 1%;
  width: 100%;
  height: 100%;
  color: black;
  border: 1px solid black;
}

.status-frequencia {
  font-size: 12px;
}

.ultimo-encontro {
  border-radius: 0 0 10px 10px;
  overflow: hidden;
  border-bottom: 2px solid black;
}

#selecionar button {
  background-color: #6f319aff;
  color: white;
  height: 100%;
  border: none;
  width: 100%;
  padding: 5px 10px;
  cursor: pointer;
}

#selecionar button:hover {
  background-color: rgba(110, 49, 154, 0.718);
  transition: 300ms;
}

#cabecalho-participante {
  width: 90%;
  display: grid;
  grid-template-columns: 70% repeat(2, 15%);
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #6f319aff;
}

#cabecalho-participante div {
  border: 1px solid black;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

#cabecalho-participante p {
  margin-bottom: 0px;
  color: white;
}

#cabecalho-participante button {
  background-color: white;
  border-radius: 5px;
  border: #6F319A;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 4%;
}

.participantes {
  display: grid;
  width: 90%;
  grid-template-columns: 70% repeat(2, 15%);
  justify-items: center;
  align-items: center;
  background-color: white;
}

.participantes div {
  text-align: center;
  align-content: center;
  margin: 0.5% 0;
  width: 100%;
  height: 100%;
  color: black;
  border: 1px solid black;
}

.form-check-input {
  border: 2px solid #6f319aff;
  cursor: pointer;
}

.form-check-input:focus {
  box-shadow: none;
}

.form-check-input:checked {
  background-color: #6F319A;
  border-color: #6F319A;
}

.faltou {
  transition: 300ms;
  background-color: rgb(255, 227, 227);
  cursor: pointer;
}

.presente {
  transition: 300ms;
  background-color: rgb(226, 255, 226);
  cursor: pointer;
}

#botoes {
  margin-top: 2%;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.voltar {
  background-color: white;
}

.salvar {
  background-color: #6F319A;
  color: white;
}

.cabecalho-form {
  position: relative;
  background-color: var(--azul-escuro);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 100%;
  padding: 0;
  color: var(--branco);
  overflow: hidden;
}

.cabecalho-form > h4 {
  margin: 0;
  padding: 0;
  font-weight: bold;
  font-size: 1.2rem;
  border: none;
  text-transform: uppercase;
}

.cabecalho-form button {
  position: absolute; 
  right: 0; 
  top: 0;  
  height: 100%; 
  width: 60px;  
  background-color: var(--vermelho); 
  border: none;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;
}

.cabecalho-form button:hover {
  background-color: #cc0000; 
}*/
:root {
  --roxo-sistema: #6f319aff;
  --azul-escuro: #0a1f4d; /* Exemplo */
  --verde-badge: #00c853;
  --amarelo-badge: #ffab00;
}

#cadastro {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center; /* Centraliza o modal na tela */
}

.container-tabela {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.form {
  width: 100%; /* Largura do modal */
  max-width: 900px;
  background-color: white;
  padding: 0;
  border-radius: 0 0 10px 10px;
  overflow: hidden; /* Importante para o cabeçalho */
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.form h4 {
  margin: 0;
  padding-bottom: 5px;
  font-weight: 500;
  text-transform: uppercase;
  border: none;
  color: #000;
}

.atividade-infos {
  color: #000;
  text-align: center;
}

/* --- CABEÇALHO AZUL --- */
.cabecalho-form {
  position: relative;
  background-color: #0d1b42; /* Azul bem escuro conforme a imagem */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  color: white;
}

.cabecalho-form button {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50px;
  background-color: #ff0000;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* --- CORPO DO MODAL --- */
.modal-body {
  padding: 20px 50px; /* Espaço branco ao redor do conteúdo */
  max-height: 80vh;
  overflow-y: auto;
  width: 100%;
}

.instrucao {
  font-weight: bold;
  margin: 20px 0px 10px 0;
  color: #000;
  text-align: left;
  width: 85%;
}

/* --- TABELA ESTILO IMAGEM --- */
.tabela-customizada {
  width: 90%;
  overflow: hidden;
  border-radius: 5px;
}

.tabela-titulo {
  background-color: #6f319aff; /* Roxo principal */
  color: white;
  text-align: center;
  padding: 8px;
  font-weight: bold;
  font-size: 1rem;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

thead tr {
  background-color: var(
    --roxo-escuro1
  ); /* Roxo um pouco mais escuro para o cabeçalho das colunas */
  color: white;
}

th {
  padding: 10px;
  text-align: center;
  font-weight: normal;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

th:last-child {
  border-right: none;
}

tbody tr {
  background-color: #e0e0e0; /* Cinza claro para as linhas */
  cursor: pointer;
  border-bottom: 1px solid white; /* Efeito de separação */
}

tbody tr:nth-child(even) {
  background-color: #ebebeb; /* Alternância sutil de cor se desejar */
}

tbody tr:hover {
  filter: brightness(0.95); /* Efeito hover na linha */
}

td {
  padding: 10px;
  text-align: center;
  color: black;
  vertical-align: middle;
}

/* --- BADGES DE STATUS --- */
.coluna-status {
  width: 200px; /* Largura fixa para a coluna de status */
}

.badge-status {
  padding: 6px 10px;
  border-radius: 4px;
  color: white;
  font-weight: 500;
  font-size: 0.85rem;
  text-align: center;
  width: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.verde {
  background-color: #00c853; /* Verde vibrante */
}

.amarelo {
  background-color: #ffc107; /* Amarelo ouro */
  color: white; /* Texto branco no amarelo conforme imagem, ou preto se preferir legibilidade */
}

.roxo {
  background-color: #772fa2; /* Roxo do sistema */
  color: white;
}

.cinza {
  background-color: #9e9e9e; /* Cinza para desabilitado */
  color: white;
}

tbody tr.desabilitado {
  cursor: not-allowed;
  opacity: 0.6;
}

tbody tr.desabilitado:hover {
  filter: brightness(0.95);
  cursor: not-allowed;
}

/* --- ESTILOS ANTIGOS DE PARTICIPANTES (PRESERVADOS) --- */
#cabecalho-participante {
  background-color: #6f319aff;
  color: white;
  display: grid;
  grid-template-columns: 70% 15% 15%;
  padding: 5px;
  margin-top: 10px;
  border-radius: 5px 5px 0 0;
}
.participantes {
  display: grid;
  grid-template-columns: 70% 15% 15%;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
}
/* ... Adicione o resto dos estilos de participantes aqui ... */
#botoes {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 15px;
}
.voltar,
.salvar {
  padding: 8px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.voltar {
  background-color: #ccc;
}
.salvar {
  background-color: #6f319aff;
  color: white;
}
</style>
